module.exports = __webpack_public_path__ + "img/en_US-SWSH1-138-zacian_v.a952f239.jpg";